import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import { SVGProps } from 'react';

import LogoSVG from './assets/logo.svg?component';
import { BaseUIComponentProps } from './base';

export type LogoColor = 'white' | 'black' | 'lightGreen' | 'racingGreen';
export type LogoSize = 'sm' | 'md' | 'lg';

const logoSizes = cva('', {
    variants: {
        size: {
            sm: 'w-[93px] h-[24px]',
            md: 'w-[124px] h-[32px]',
            lg: 'w-[155px] h-[40px]',
        },
    },

    defaultVariants: {
        size: 'md',
    },
});

const logoVariants = cva('', {
    variants: {
        color: {
            white: 'text-white',
            black: 'text-black',
            lightGreen: 'text-lightGreen',
            racingGreen: 'text-racingGreen',
        },
    },

    defaultVariants: {
        color: 'lightGreen',
    },
});

export type LogoProps = {
    size?: LogoSize;
    color?: LogoColor;
} & BaseUIComponentProps &
    SVGProps<SVGSVGElement>;

export const Logo = ({ color = 'lightGreen', size = 'md', className, ...props }: LogoProps) => {
    const sizeMap = {
        sm: { width: 93, height: 24 },
        md: { width: 124, height: 32 },
        lg: { width: 155, height: 40 },
    };
    return (
        <LogoSVG
            className={classNames(
                logoVariants({
                    color,
                }),
                logoSizes({ size }),
                className
            )}
            width={sizeMap[size].width}
            height={sizeMap[size].height}
            viewBox="0 0 155 40" // Ensure this matches the SVG's natural dimensions
            {...props}
        />
    );
};
